import { createHobbyToolsClient, SupabaseProvider } from '@hobbytools/data';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useEffect, useState } from 'react';
import { AuthProvider } from './auth/AuthProvider';
import type { PlatformConfig } from './auth/config';
import { startMonitoring } from './monitoring';
import { SandboxNotice } from './SandboxNotice';

/** App-level providers shared by every app: Supabase client, query cache, auth session, error reporting (plus the sandbox notice). */
export function PlatformProvider({ config, children }: { config: PlatformConfig; children: ReactNode }) {
  useEffect(() => startMonitoring(config.monitoring), [config.monitoring]);
  const [client] = useState(() => createHobbyToolsClient(config.supabaseUrl, config.supabasePublishableKey));
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } }),
  );
  return (
    <SupabaseProvider client={client}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider providers={config.authProviders}>
          {config.sandbox ? <SandboxNotice /> : null}
          {children}
        </AuthProvider>
      </QueryClientProvider>
    </SupabaseProvider>
  );
}
